import { render, staticRenderFns } from "./ViewTransactions.vue?vue&type=template&id=6916ce47&scoped=true"
import script from "./ViewTransactions.vue?vue&type=script&lang=js"
export * from "./ViewTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6916ce47",
  null
  
)

export default component.exports